import invariant from 'invariant';

import { configString } from '#/config/appConfigUtils';
import { isNotEmpty } from '#/utils/functional/poly';

export function getSearchAlgoliaDefaultConfig(): {
  appId: string;
  apiKey: string;
} {
  const appId = configString('algolia', 'appId');
  const apiKey = configString('algolia', 'searchApiKey');

  invariant(isNotEmpty(appId), 'appId cannot be empty');
  invariant(isNotEmpty(apiKey), 'apiKey cannot be empty');

  return { appId, apiKey };
}

export function getSearchAlgoliaConfigWithApiKey(apiKey: string) {
  return { ...getSearchAlgoliaDefaultConfig(), apiKey };
}
